import React from 'react';
import LoanTenure from './LoanTenure'
import Payhinga from './Modal/Payhinga'

export const InstallmentTerms = (props) => {
    const params = {
        loanableAmount: props.loanableAmount,
        selected: props.selected,
        getEMIDetails: props.getEMIDetails,
        vasTenureList: props.vasTenureList,
        VASFlag: props.VASFlag,
        productTenur: props.productTenur,
        formatter: props.formatter,
        emiCalculator: props.emiCalculator,
        vasEmiCalculator: props.vasEmiCalculator,
        loadVAS: true,
        hideTenure: props.hideTenure
    };
    let showTenure = false;
    if ((props.RBPObject.status === 'N') && (props.loanableAmount >= props.minLoanAmount)) {
        showTenure = true;
    } else if ((props.RBPObject.status === 'Y') && !((props.eligibleSegments.length === 0 || props.downPayment < props.addOnSelectedDp))) {
        showTenure = true;
    }
    return (
        <div className="payment-checks overflow-auto">
            <div className="title">Installment terms</div>
            {props.isProcessFeeApplicable ? <p className="sil-zero-proccessfee">Inclusive of processing fee**</p> : ""}
            <div className="sub-title" style={{ fontWeight: "400", color: "#373739" }}>
                Tanungin si client sa kanyang preferred loan term
            </div>
            <div className="sub-title mb-2">
                <Payhinga />
            </div>
            {
                showTenure ? (
                    <>
                        <LoanTenure {...params} />
                    </>
                ) : ''}
        </div>
    );
};
export default InstallmentTerms;